import { Links, Meta } from 'react-router'

export const ErrorWrapper = ({ error }: { error: Error }) => {
  console.error('Error: ', error)
  return (
    <html lang="en" className="h-full">
      <head>
        <Meta />
        <Links />
      </head>
      <body className="container mx-auto max-w-[1440px] bg-[#fafafa] pt-0 print:text-sm">
        <div className="container mx-auto flex h-screen flex-col  bg-[url('/images/branded-bg.png')] bg-contain bg-contain bg-[length:100%_40%] bg-bottom bg-no-repeat px-5 pt-2 md:px-20 lg:mb-4 lg:px-52 lg:pb-0">
          <div>
            <header className="mt-10 items-end pb-6">
              <img
                src="/images/logo-bctransplant.png"
                alt="BC Transplant"
                className="mx-auto  mx-0 h-16 md:mr-2"
              />
            </header>
            <h3 className="pb-3 text-[44px] font-semibold text-red-800">Unexpected Error...</h3>
          </div>
          <div className="container flex-grow ">
            <div className="flex max-w-[710px] flex-col rounded-lg border-2 border-solid border-[#6FCF97] bg-[#fafafa]  drop-shadow-[4px_4px_4px_rgba(0,0,0,0.25)] ">
              <div className="py-10 px-10 pb-5 xl:px-28">
                <div className={'mt-0 pt-0'}>
                  <div className="mb-3 flex flex-wrap items-start justify-end sm:justify-start">
                    <div className="text-red-800">Oh no, something went wrong!</div>
                  </div>
                </div>
              </div>
              <div className="bg-[#58b847] py-10 px-10 text-slate-100 xl:px-28">
                <form method="get">
                  <button className="mr-4 rounded-full bg-primary-blue px-6 py-2 text-2xl text-slate-50 transition-colors duration-300 hover:bg-[#2a60de] print:hidden">
                    Try again.
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  )
}
